/**
 * Canonical list URL search: page 1 has no `page` query param; page > 1 sets `?page=N`.
 * Used by TanStack Router `validateSearch` so `search` is optional on Link/navigate (page defaults to 1).
 *
 * `cookie_notice` is a debug/preview flag to force-show the EU cookie banner.
 */
export type ListPageSearchParams = {
  page?: number;
  cookie_notice?: boolean;
  highlight?: string;
};

function parseCookieNoticeFlag(value: unknown): boolean {
  return value === true || value === '1' || value === 'true';
}

export function validateListPageSearch(
  search: Record<string, unknown>,
): ListPageSearchParams {
  const parsedPage = search.page ? parseInt(search.page as string, 10) || 1 : 1;
  const result: ListPageSearchParams = {};
  if (parsedPage > 1) {
    result.page = parsedPage;
  }
  if (parseCookieNoticeFlag(search.cookie_notice)) {
    result.cookie_notice = true;
  }
  // Preserve ?highlight= for note-popover jumps (coerce to string — ids arrive as
  // JSON numbers from the backend and non-strings are dropped by route consumers).
  if (search.highlight != null && search.highlight !== '') {
    result.highlight = String(search.highlight);
  }
  return result;
}
